import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=ae10ea14&scoped=true&"
import script from "./ViewProfile.vue?vue&type=script&lang=js&"
export * from "./ViewProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae10ea14",
  null
  
)

export default component.exports